import HospitalityCategories from './Categories';
import HospitalityCategoryDetails from './HospitalityCategoryDetails';
import HospitalityCategoryPage from './HospitalityCategoryPage';
import type { HospitalityOptions } from './types';

const Hospitality = ({ options }: { options: HospitalityOptions }) => {
  const { view } = options;

  if (view === 'list') {
    return <HospitalityCategories options={options} />;
  }

  if (options?.contentTypeAreTickets) {
    return <HospitalityCategoryPage options={options} />;
  }

  return <HospitalityCategoryDetails options={options} />;
};
export default Hospitality;
